import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbstractComponent, CompanyService } from 'lib-trend-core';
import { catchError, of, takeUntil } from 'rxjs';
import { Constants } from '../../../../environments/constantes';

export const IMPROVEMENT_RANKING_MODAL_TITLE_ID = 'improvement-ranking-modal-title';

export const IMPROVEMENT_RANKING_MODAL_CONFIG: MatDialogConfig = {
  width: '1100px',
  maxWidth: '95vw',
  ariaLabelledBy: IMPROVEMENT_RANKING_MODAL_TITLE_ID,
};

/**
 * The Trend Gestão improvements ranking, embedded as it is served. The company and the person
 * asking go in the link, so the page already knows who is filing a request — and the API signs
 * that link, which is what lets the company vote. A signed link lasts 24 hours, so it is asked
 * for every time the modal opens and never kept.
 */
@Component({
  selector: 'improvement-ranking-modal',
  templateUrl: './improvement-ranking-modal.component.html',
  styleUrls: ['./improvement-ranking-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImprovementRankingModalComponent extends AbstractComponent {

  readonly titleId = IMPROVEMENT_RANKING_MODAL_TITLE_ID;
  /** Unset until the API answers: the frame is loaded once, with the link it should have. */
  rankingUrl: SafeResourceUrl;

  constructor(
    injector: Injector,
    private readonly dialogRef: MatDialogRef<ImprovementRankingModalComponent>,
    domSanitizer: DomSanitizer,
    companyService: CompanyService,
  ) {
    super(injector);
    companyService.getImprovementRankingLink().pipe(
      // Without the API's answer the ranking still opens — unsigned, so read-only.
      catchError(() => of({
        empresa: this.getNameCompanyCurrentUser(),
        nome: `${this.getNameCurrentUser()} (${this.getEmailCurrentUser()})`,
      })),
      takeUntil(this.destroy$),
    ).subscribe((identity) => {
      const params = new URLSearchParams({ embed: '1', ...identity });
      this.rankingUrl = domSanitizer.bypassSecurityTrustResourceUrl(`${Constants.improvementRankingUrl}?${params}`);
    });
  }

  close(): void {
    this.dialogRef.close();
  }

}
